import { useCallback, useState } from "react";
import type { TrainingHomeModule } from "@/lib/api/training-simulator/training-simulator";

const findDefaultExpandedModuleId = (
  modules: TrainingHomeModule[],
): string | null => {
  const active = modules.find((module) =>
    module.levels.some(
      (level) => level.state === "start" || level.state === "resume",
    ),
  );
  if (active) return active.id;

  const firstUnlocked = modules.find((module) => module.unlocked);
  return firstUnlocked?.id ?? modules[0]?.id ?? null;
};

export const useTrainingExpandedModules = (modules: TrainingHomeModule[]) => {
  const [overrides, setOverrides] = useState<Record<string, boolean>>({});
  const defaultExpandedId = findDefaultExpandedModuleId(modules);

  const isExpanded = useCallback(
    (moduleId: string) => overrides[moduleId] ?? moduleId === defaultExpandedId,
    [overrides, defaultExpandedId],
  );

  const toggle = useCallback(
    (moduleId: string) => {
      setOverrides((prev) => ({
        ...prev,
        [moduleId]: !(prev[moduleId] ?? moduleId === defaultExpandedId),
      }));
    },
    [defaultExpandedId],
  );

  return { isExpanded, toggle };
};
